import Vue from 'vue';
import Router from 'vue-router';
const Login = () => import('./components/Login.vue');
const Home = () => import('./views/Home.vue');
const Dashboard = () => import('./components/Dashboard.vue');
const Calendar = () => import('./components/Calendar.vue');
const Ordenar = () => import('./components/Ordenar.vue');
const Registro = () => import('./components/Registro.vue');
const CrearUsuario = () => import('./components/CrearUsuario.vue');
const CrearUsuarioCliente = () => import('./components/CrearUsuarioCliente.vue');
const CrearOrden = () => import('./components/CrearOrden.vue');
const RepVentas = () => import('./components/RepVentas.vue');
const RepReservas = () => import('./components/RepReservas.vue');
const RepCompras = () => import('./components/RepCompras.vue');
const Facturar = () => import('./components/Facturar.vue');
const Ordenes = () => import('./components/Ordenes.vue');
const CuentasPorCobrar = () => import('./components/CuentasPorCobrar.vue');
const CuentasPorPagar = () => import('./components/CuentasPorPagar.vue');
const MisOrdenes = () => import('./components/MisOrdenes.vue');
const Clientes = () => import('./components/Clientes.vue');
const Features = () => import('./components/Features.vue');
const PreAviso = () => import('./components/PreAviso.vue');
const Proformas = () => import('./components/Proformas.vue');
const InvActual = () => import('./components/InvActual.vue');
const Afiliacion = () => import('./components/Afiliacion.vue');
const Compras = () => import('./components/Compras.vue');
const AceptarProforma = () => import('./components/AceptarProforma.vue');
const Ticket = () => import('./components/Ticket.vue');
const PerfilCliente = () => import('./components/PerfilCliente.vue');
const Conteos = () => import('./components/Conteos.vue');
const Rol = () => import('./components/Rol.vue');
const Reparaciones = () => import('./components/Reparaciones.vue');
const CreditosPagados = () => import('./components/CreditosPagados.vue');
const RepXproducto = () => import('./components/RepXproducto.vue');
const Seriales = () => import('./components/Seriales.vue');
const Tutoriales = () => import('./components/Tutoriales.vue');
const MovimientoProductos = () => import('./components/MovimientoProductos.vue');
const PanelControl = () => import('./components/PanelControl.vue');
const Licencias = () => import('./components/Licencias.vue');
const ProductosWeb = () => import('./components/ProductosWeb.vue');
const ProductosWebBodega = () => import('./components/ProductosWebBodega.vue');
const Cocina = () => import('./components/Cocina.vue');
const Bar = () => import('./components/Bar.vue');
const Despacho = () => import('./components/Despacho.vue');
const Botones = () => import('./components/Botones.vue');
const RepClientes = () => import('./components/RepClientes.vue');
const Localidades = () => import('./components/Localidades.vue');
const POS = () => import('./components/POS.vue');
const ReporteCrudo = () => import('./components/ReporteCrudo.vue');
const Calendario = () => import('./components/Calendario.vue');
const Cierre = () => import('./components/Cierre.vue');
const Compuestos = () => import('./components/Compuestos.vue');
const Recetas = () => import('./components/Recetas.vue');
const FeedBack = () => import('./components/FeedBack.vue');
const Odt = () => import('./components/Odt.vue');
const ConfirmarCita = () => import('./components/ConfirmarCita.vue');
const ResEntrantes = () => import('./components/ResEntrantes.vue');
import store from './store'; // This is not a Vue component, so it remains the same
const RepProductoDetallado = () => import('./components/RepProductoDetallado.vue');
const RepXVendedor = () => import('./components/RepXVendedor.vue');
const HomeQuinchos = () => import('./components/HomeQuinchos.vue');
const EstadoBancario = () => import('./components/EstadoBancario.vue');
const Promociones = () => import('./components/Promociones.vue');
const ComandasAdmin = () => import('./components/ComandasAdmin.vue');
const TarjetaRegalo = () => import('./components/TarjetaRegalo.vue');
const DespachoMensajero = () => import('./components/DespachoMensajero.vue');
const Politicas = () => import('./components/Politicas.vue');
const InventarioAsignado = () => import('./views/InventarioAsignado.vue');
const ReporteMinimos = () => import('./views/ReporteMinimos.vue');
const ReporteCategorias = () => import('./views/ReporteCategorias.vue');
const ProductosEstancados = () => import('./views/ProductosEstancados.vue');
const Panorama = () => import('./components/Panorama.vue');
const AjusteInventario = () => import('./components/AjusteInventario.vue');
const ReporteTraslados = () => import('./components/ReporteTraslados.vue');
const TrazabilidadInvernadero = () => import('./components/TrazabilidadInvernadero.vue');
const RepXMensajero = () => import('./components/RepXMensajero.vue');
const OrdenExpress = () => import('./components/OrdenExpress.vue');
const RepComprasProveedor = () => import('./components/RepComprasProveedor.vue');
const OrdenesTaller = () => import('./components/OrdenesTaller.vue');
const VentasXero = () => import('./components/VentasXero.vue');
const Aprobaciones = () => import('./components/Aprobaciones.vue');
const Trazabilidad = () => import('./components/Trazabilidad.vue');
const Botonera = () => import('./components/Botonera.vue');
const VentasXHoras = () => import('./components/VentasXHoras.vue');

Vue.use(Router)

var router = new Router({
mode: 'history',
base: process.env.BASE_URL,
routes: [
		{
			path: '/',
			name: '',
			component: Home,
			meta : {
				libre: true,
			}
		},
		{
			path: '/repxmensajero',
			name: 'repxmensajero',
			component: RepXMensajero,
			meta : {
				libre: true,
			}
		},
		
		{
			path: '/ordenexpress',
			name: 'ordenexpress',
			component: OrdenExpress,
			meta : {
				libre: true,
			}
		},
		{
			path: '/trazabilidadinv',
			name: 'trazabilidadinv',
			component: TrazabilidadInvernadero,
			meta : {
				libre: true,
			}
		},
		{
			path: '/panorama',
			name: 'panorama',
			component: Panorama,
			meta : {
				libre: true,
			}
		},
		{
			path: '/reportetraslados',
			name: 'reportetraslados',
			component: ReporteTraslados,
			meta : {
				libre: true,
			}
		},
		{
			path: '/productosestancados',
			name: 'productosestancados',
			component: ProductosEstancados,
			meta : {
				libre: true,
			}
		},
		{
			path: '/ajusteinventario',
			name: 'ajusteinventario',
			component: AjusteInventario,
			meta : {
				libre: true,
			}
		},
		{
			path: '/reportecategorias',
			name: 'reportecategorias',
			component: ReporteCategorias,
			meta : {
				libre: true,
			}
		},
		{
			path: '/inventarioasignado',
			name: 'inventarioasignado',
			component: InventarioAsignado,
			meta : {
				libre: true,
			}
		},
		{
			path: '/reporteminimos',
			name: 'reporteminimos',
			component: ReporteMinimos,
			meta : {
				libre: true,
			}
		},
		{
			path: '/ventasxhora',
			name: 'ventasxhora',
			component: VentasXHoras,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor','King Encargado','King Boss']
			}
		},
		{
			path: '/comprasproveedor',
			name: 'comprasproveedor',
			component: RepComprasProveedor,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor','King Encargado','King Boss']
			}
		},
		{
			path: '/botonera',
			name: 'botonera',
			component: Botonera,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor','King Encargado','King Boss']
			}
		},
		{
			path: '/trazabilidad',
			name: 'trazabilidad',
			component: Trazabilidad,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor','King Encargado','King Boss']
			}
		},
		{
			path: '/ventasxero',
			name: 'ventasxero',
			component: VentasXero,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor','King Encargado','King Boss','Contador']
			}
		},
		{
			path: '/aprobaciones',
			name: 'aprobaciones',
			component: Aprobaciones,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor','King Encargado','King Boss','Contador','Vendedor']
			}
		},
		{
			path: '/pos',
			name: 'pos',
			component: POS,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor', 'Vendedor','King Encargado','King Boss']
			}
		},
		{
			path: '/ordenestaller',
			name: 'ordenestaller',
			component: OrdenesTaller,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor', 'Vendedor','King Encargado','King Boss','Gerente Taller']
			}
		},
		{
			path: '/politicas',
			name: 'politicas',
			component: Politicas,
			meta: {
			rol: ['libre']
			}
		},
		
		{
			path: '/tarjetaderegalo',
			name: 'tarjetaderegalo',
			component: TarjetaRegalo,
			meta : {
			libre: true,
			}
		},
		{
			path: '/reservasentrantes',
			name: 'reservasentrantes',
			component: ResEntrantes,
			meta : {
			libre: true,
			}
		},
		{
			path: '/despachomensajero',
			name: 'despachomensajero',
			component: DespachoMensajero,
			meta : {
			libre: true,
			}
		},
		{
			path: '/estadobancario',
			name: 'estadobancario',
			component: EstadoBancario,
			meta : {
			libre: true,
			}
		},
		{
			path: '/test',
			name: 'test',
			component: HomeQuinchos,
			meta : {
			libre: true,
			}
		},
		{
			path: '/odt',
			name: 'odt',
			component: Odt,
			meta : {
			libre: true,
			}
		},
		{
		path: '/repxproducto',
		name: 'repxproducto',
		component: RepXproducto,
		meta : {
			administrador: true,
			supervisor: true,
			vendedor: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		
		{
		path: '/botones',
		name: 'botones',
		component: Botones,
		meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/reportecrudo',
			name: 'reportecrudo',
			component: ReporteCrudo,
			meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
			path: '/repxvendedor',
			name: 'repxvendedor',
			component: RepXVendedor,
			meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
			path: '/recetas',
			name: 'recetas',
			component: Recetas,
			meta : {
			libre: true,
			}
		},
		{
			path: '/tutoriales',
			name: 'tutoriales',
			component: Tutoriales,
			meta : {
			libre: true,
			}
		},
		{
			path: '/compuestos',
			name: 'compuestos',
			component: Compuestos,
			meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		
		{
			path: '/bar',
			name: 'bar',
			component: Bar,
			meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
		path: '/seriales',
		name: 'seriales',
		component: Seriales,
		meta : {
			administrador: true,
			supervisor: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/feedback',
			name: 'feedback',
			component: FeedBack,
			meta : {
			libre: true,
			}
		},
		{
		path: '/creditospagados',
		name: 'creditospagados',
		component: CreditosPagados,
		meta : {
			administrador: true,
			supervisor: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/panelcontrol',
			name: 'panelcontrol',
			component: PanelControl,
			meta : {
			administrador: true,
			supervisor: true,
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
		path: '/ticket/:id',
		name: 'ticket',
		component: Ticket,
		meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/cierre/:id',
			name: 'cierre',
			component: Cierre,
			meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
		path: '/perfilcliente/:localidad/:id',
		name: 'perfilcliente',
		component: PerfilCliente,
		meta : {
			libre: true,
		}
		},
		{
			path: '/facturar/:id/:localidad',
			name: 'facturar',
			component: Facturar,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor', 'Vendedor','King Boss','King Encargado']
			}
			
		},
		{
			path: '/compras',
			name: 'compras',
			component: Compras,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor', 'Vendedor']
				}
			},
		{
		path: '/aceptarproforma/:id/:localidad',
		name: 'aceptarproforma',
		component: AceptarProforma,
		meta : {
			libre: true,
		}
		},
		{
			path: '/confirmarcita/:id/:localidad/:fecha',
			name: 'confirmarcita',
			component: ConfirmarCita,
			meta : {
			libre: true,
			}
		},
		{
		path: '/conteos/:id/',
		name: 'conteos',
		component: Conteos,
		meta : {
			libre: true,
		}
		},
		{
		path: '/login',
		name: 'login',
		component: Login,
		meta : {
			administrador: true,
			almacenero: true,
			vendedor: true,
			libre: true,
		}
		},
		{
		path: '/registro',
		name: 'registro',
		component: Registro,
		meta : {
			administrador: true,
			almacenero: true,
			vendedor: true,
			libre: true,
		}
		},
		{
		path: '/repventas',
		name: 'repventas',
		component: RepVentas,
		meta: {
			requiresAuth: true, // Indica que la ruta requiere autenticación
			rol: ['Administrador', 'Supervisor', 'Vendedor']
			
		},
		},
		{
			path: '/represervas',
			name: 'represervas',
			component: RepReservas,
			meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
		path: '/repcompras',
		name: 'repcompras',
		component: RepCompras,
		meta : {
			administrador: true,
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
		path: '/proformas',
		name: 'proformas',
		component: Proformas,
		meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
		path: '/inventarioactual',
		name: 'inventarioactual',
		component: InvActual,
		meta : {
			libre: true,
			supervisor: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
		path: '/misordenes',
		name: 'misordenes',
		component: MisOrdenes,
		meta : {
			administrador: true,
			supervisor: true,
			vendedor: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
		path: '/reparaciones',
		name: 'reparaciones',
		component: Reparaciones,
		meta : {
			administrador: true,
			supervisor: true,
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
		path: '/usuarios',
		name: 'usuarios',
		component: CrearUsuario,
		meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/licencias',
			name: 'licencias',
			component: Licencias,
			meta : {
				administrador: true,
				requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
			path: '/productosweb',
			name: 'productosweb',
			component: ProductosWeb,
			meta : {
				libre: true,
				requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/productoswebbodega',
			name: 'productoswebbodega',
			component: ProductosWebBodega,
			meta : {
				libre: true,
				requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/promociones',
			name: 'promociones',
			component: Promociones,
			meta : {
				libre: true,
				requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/productosdetallados',
			name: 'productosdetallados',
			component: RepProductoDetallado,
			meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
		path: '/usuariocliente',
		name: 'usuariocliente',
		component: CrearUsuarioCliente,
		meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
		path: '/calendar',
		name: 'calendar',
		component: Calendar,
		meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/calendario',
			name: 'calendario',
			component: Calendario,
			meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
		path: '/afiliacion',
		name: 'afiliacion',
		component: Afiliacion,
		meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
		path: '/clientes',
		name: 'clientes',
		component: Clientes,
		meta : {
			administrador: true,
			supervisor: true,
		}
		},
		{
			path: '/localidades',
			name: 'localidades',
			component: Localidades,
			meta : {
			administrador: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
		path: '/ordenes',
		name: 'ordenes',
		component: Ordenes,
		meta : {
			libre: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
		path: '/ordenar',
		name: 'ordenar',
		component: Ordenar,
		meta : {
			administrador: true,
			supervisor: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
			vendedor: true,
		}
		},
		{
			path: '/movimientoproductos',
			name: 'movimientoproductos',
			component: MovimientoProductos,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor', 'Vendedor','King Boss','King Encargado']
			}
		},
		{
		path: '/crearorden',
		name: 'crearorden',
		component: CrearOrden,
		meta : {
			administrador: true,
			supervisor: true,
			vendedor: true,
			requiresAuth: true, // Indica que la ruta requiere autenticación
		}
		},
		{
			path: '/cuentasporcobrar',
			name: 'cuentasporcobrar',
			component: CuentasPorCobrar,
			meta : {
				libre: true,
				requiresAuth: true, // Indica que la ruta requiere autenticación
			}
		},
		{
			path: '/cuentasporpagar',
			name: 'cuentasporpagar',
			component: CuentasPorPagar,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor', 'Vendedor','King Boss','King Encargado']
			}
		},
		{
			path: '/features',
			name: 'features',
			component: Features,
			meta : {
				administrador: true,
				libre: true,
				
			}
		},
		{
			path: '/despacho',
			name: 'despacho',
			component: Despacho,
			meta : {
				administrador: true,
				libre: true,
				mensajero: true,
			}
		},
		{
			path: '/comandasadmin',
			name: 'comandasadmin',
			component: ComandasAdmin,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor', 'Vendedor','King Boss','King Encargado']
			}
		},
		{
			path: '/cocina',
			name: 'cocina',
			component: Cocina,
			meta : {
				administrador: true,
				libre: true,
			}
		},
		{
			path: '/preaviso',
			name: 'preaviso',
			component: PreAviso,
			meta : {
				administrador: true,
				libre: true,
			}
		},
		{
			path: '/id',
			name: '',
			meta : {
				administrador: true,
			}
		},
		
		{
			path: '/rol',
			name: 'rol',
			component: Rol,
			meta : {
				administrador: true,
				supervisor: true,
			}
		},
		{
			path: '/repclientes',
			name: 'repclientes',
			component: RepClientes,
			meta: {
				requiresAuth: true, // Indica que la ruta requiere autenticación
				rol: ['Administrador', 'Supervisor', 'Vendedor','King Boss','King Encargado']
			}
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: Dashboard,
			meta: {
				
				rol: ['Administrador', 'Supervisor', 'Vendedor','King Boss','King Encargado']
			}
		}
  ]
})

// Nav Guard

router.beforeEach((to, from, next) => {
	if (!store.state.tokenChecked) {
	  store.dispatch('autoLogin').then(() => {
		// Ahora realiza la comprobación de autenticación después de que autoLogin se haya completado
		const isAuthenticated = store.state.usuario;
		if (to.meta.requiresAuth && !isAuthenticated) {
		  next({ name: 'login' });
		} else {
		  next();
		}
	  });
	} else {
	  const isAuthenticated = store.state.usuario;
	  if (to.meta.requiresAuth && !isAuthenticated) {
		next({ name: 'login' });
	  } else {
		next();
	  }
	}
  });
  

export default router

